import { bl_applet_notification_hdr_RowClass } from "../../dbschema";
import { BaseContainerModel } from "../base-container.model";

export class AppletNotificationHdrModel extends BaseContainerModel {
    bl_applet_notification_hdr: bl_applet_notification_hdr_RowClass = new bl_applet_notification_hdr_RowClass();
}